<script>
import resources from './resources'
import APP_URL from '@/plugins/http/appURL'

export default {
  name: 'gadget-staff',
  mixins: [resources],
  data: () => {
    return {
      mobileMenuOn: false,
      APP_URL: APP_URL
    }
  },
  methods: {
    goToTerms () {
      location.href = this.APP_URL + '/app/terms/term'
    },
    goToPolicy () {
      location.href = this.APP_URL + '/app/terms/policy'
    }
  }
}
</script>

<template lang="pug">
page(title="Bem-vindo(a) ao Medibook!")
  section#intro.container-fluid(role="banner")
    .container
      .content.col-sm-8.col-sm-offset-2
        h1
          | Agende sua próxima consulta!
          br
        .text
          | Rápido, simples e sem custo. Aproveite!
        div
          .col-xs-12.col-md-6
            label.pull-left Especialidade
            br
            mb-select(
              v-model="search.speciality",
              placeholder="Especialidade",
              label="name",
              track-by="id",
              :options="specialities",
              :multiple="true",
              :limit="1",
              :max="1",
              :taggable="true",
              :loading="loading",
              :disabled="specialities.length <= 0",
              @input="onSelectedSpeciality"
            )

          .col-xs-12.col-md-6
            label.pull-left Cidade atual:
              span(style="color: #2071b6")
                strong Curitiba
            br
            mb-select(
              v-model="search.city",
              placeholder="Cidade",
              label="name",
              track-by="id",
              :options="cities",
              :multiple="true",
              :limit="1",
              :max="1",
              :taggable="true",
              @input="onSelectedCity"
            )
            //-f-select-loading-cities(
              v-model="search.city",
              name="cityName",
              :get-all="true",
              :searchable="true",
              @selected="onSelectedCity",
              placeholder='Cidade/UF')
          .col-xs-12.col-md-12
            h5
              | Para pesquisa&nbsp;
              strong Avançada&nbsp;
              | ou pelo&nbsp;
              strong Nome do Profissional
              | , faça seu login.

            a.mb-cursor-pointer(@click.prevent="doSearch()")
              #search
                | Buscar
                span.icon 
  section#results(
    :class="{ displaynone: !notShow, displayblock: isBlock }",
    v-if="loading"
  )
    .loading-screen(
      v-show="loading",
      v-bind:class="classes",
      v-bind:style="{ backgroundColor: bc }"
    )
      component(v-if="customLoader", v-bind:is="customLoader")
      div(v-else="")
        .loading-circle
        p.loading-text
          strong {{ text }}
  section#results(
    :class="{ displaynone: !notShow, displayblock: isBlock }",
    v-if="!loading"
  )
    .container(style="padding-top: 100px;")
      .results.col-xs-12
        h2(v-if="showLabelSearch")
          div(v-if="scheduleTotal == 0")
            | Não encontramos agenda profissional para a sua busca
          div(v-if="scheduleTotal > 0")
            | Encontramos&nbsp;
            strong(v-if="scheduleTotal != 0")
              | {{ scheduleTotal }}&nbsp;
            span(v-if="scheduleTotal == 1")
              | agenda profissional para a sua busca
            span(v-if="scheduleTotal > 1")
              | agenda(s) profissionais para a sua busca
        .item(v-for="schedule in schedules", :key="schedule.id")
          .row
            .col-xs-12.col-sm-4.col-md-2.padding
              div
                //- Removendo para  adcionar somente a foto do company
                .avatars-company.hidden-xs(v-if="schedule.is_company")
                  span.avatar-company
                    img(
                      :src="schedule.avatar_company",
                      width="100%",
                      style="border-radius:50%; box-shadow: 0 0 0 1px #babeca;"
                    )
                  //-span.avatar-company-professional
                    img.avatar-professional(:src="schedule.avatar", width='50%', style="z-index: 8;")
                .avatars.hidden-sm.hidden-md.hidden-lg(
                  v-if="schedule.is_company"
                )
                  span.avatar
                    img(
                      :src="schedule.avatar_company",
                      width="100%",
                      style="border-radius:50%; box-shadow: 0 0 0 1px #babeca;"
                    )

                //-.avatars(v-if="!schedule.is_company")
                  span.avatar
                    img(:src="schedule.avatar", width='100%', style="border-radius:50%; box-shadow: 0 0 0 1px #babeca;")

                //-.profile-photo
                  img.img-circle(:src="schedule.avatar", v-if="!schedule.is_company")
                  img.img-circle(:src="schedule.avatar_company", v-if="schedule.is_company")
                .links
                  links-profile-professional(
                    :links="schedule.networks",
                    :documentState="schedule.document",
                    :state="schedule.professional_state",
                    v-if="!schedule.is_company"
                  )

                  links-profile-company(
                    links="schedule.networks",
                    :countryRegsiter="schedule.country_register",
                    :documentState="schedule.document",
                    :state="schedule.professional_state",
                    v-if="schedule.is_company"
                  )

            .col-xs-12.col-sm-8.col-md-10
              .row
                .col-xs-12.col-sm-12.col-md-8
                  company_information(
                    :name="schedule.company_slug",
                    :document="schedule.document",
                    :professionalState="schedule.professional_state",
                    :speciality="schedule.speciality",
                    :companySlug="schedule.company_slug",
                    :companyType="schedule.company_type",
                    :professionalName="schedule.professional",
                    :street="schedule.street",
                    :number="schedule.number",
                    :complement="schedule.component",
                    :zip="schedule.zip",
                    :district="schedule.district",
                    :city="schedule.city",
                    :extesion="schedule.complement",
                    :countryState="schedule.state",
                    v-if="schedule.is_company"
                  )
                  personal-information(
                    :name="schedule.professional",
                    :document="schedule.document",
                    :professionalState="schedule.professional_state",
                    :speciality="schedule.speciality",
                    :companySlug="schedule.company_slug",
                    :companyType="schedule.company_type",
                    :professionalName="schedule.professional",
                    :street="schedule.street",
                    :number="schedule.number",
                    :complement="schedule.complement",
                    :zip="schedule.zip",
                    :district="schedule.district",
                    :city="schedule.city",
                    :extesion="schedule.complement",
                    :countryState="schedule.state",
                    v-if="!schedule.is_company"
                  )

                  #consulta-particular(
                    v-if="schedule.price && operatorCovenant === null && schedule._parsed.price_real > 0"
                  )
                    //- small(@click.prevent="isShowPrice = !isShowPrice")
                    small.cursor-piont(
                      @click="setHide(schedule)",
                      style="font-size: 100%"
                    )
                      span.icon 
                      | Consulta Particular
                    //- div(v-show="isShowPrice", style="margin-left: 10px;")
                    div(v-if="schedule.hide", style="margin-left: 10px;")
                      small
                        .cents
                          strong Para conferir os valores particulares, realize seu login
                      //-.rs R$
                      //-.valor {{ schedule._parsed.price_real }}
                      //-.cents ,{{ schedule._parsed.price_cents }}

                .col-xs-12.col-sm-12.col-md-4
                  schedule(:agenda="schedule")
          .row
            .col-xs-12.col-sm-12.col-md-12(v-if="schedule.covenant === null")
              //- Caso nao atendo convenios
            .col-xs-12.col-sm-12.col-md-12(v-if="schedule.covenant !== null")
              label Convênios
                span(
                  v-for="covenant in schedule.covenant.split(',')",
                  v-if="covenant.trim() === operatorCovenant"
                )
                  | {{ covenant }}

              //-#planos(v-if="!schedule.is_company", style="margin-top: 5px;")
                span(v-for="covenant in schedule.covenant.split(',')", v-if="covenant.trim()  !== operatorCovenant ")
                  | {{ covenant }}

              #planos(v-if="schedule.is_company", style="margin-top: 5px;")
                span(
                  v-for="covenant in schedule.companies.covenants",
                  v-if="covenant.name.trim() === operatorCovenant"
                )
                  | {{ covenant.name }}

              #planos(
                v-if="schedule.is_company && operatorCovenant === null",
                style="margin-top: 5px;"
              )
                span(
                  v-for="covenant in schedule.companies.covenants.slice(0, 10)"
                )
                  | {{ covenant.name }}
                //- contando
                span(v-if="schedule.companies.covenants.length > 10")
                  | + {{ schedule.companies.covenants.length - 10 }}
      .col-xs-12
        .button.see-more.pull-right.no-undeline.mb-cursor-pointer(
          @click.prevent="showMoreResults()",
          v-if="scheduleTotal >= 1"
        )
          | Listar todas
          span.icon 
        br
        br
        br
  .clearfix

  section#apresentacao.container-fluid(role="definition")
    .container
      h2 Seja bem-vindo ao Medibook
      .row
        .col-xs-12.text.text-center.hidden-sm.hidden-md.hidden-lg(
          style="margin-bottom:30px;"
        )
          | Um sistema que facilita o agendamento de consultas médicas.
      .row
        .col-sm-6.col-md-4
          .item
            .icon
              img(src="/static/images/icons/01-paciente.png")
            p(style="font-size: 20px;")
              | Marque sua consulta em &nbsp;
              strong dois cliques
        .col-sm-6.col-md-4
          .item
            .icon
              img(src="/static/images/icons/03-paciente.png")
            p(style="font-size: 20px;")
              | Receba &nbsp;
              strong lembretes
              |
              | da sua consulta
        .col-sm-6.col-md-4
          .item
            .icon
              img(src="/static/images/icons/04-paciente.png")
            p(style="font-size: 20px;")
              | Conte com uma &nbsp;
              strong equipe especializada
              |
              | para dúvidas
  section#highlight.container-fluid(role="contentinfo")
    .container
      .row
        .col-sm-12.col-md-5
          h2
            | Cuidar da própria saúde
            br
            | deve ser simples!
            br
            strong Seja bem-vindo ao Medibook!
          p Um sistema que facilita o agendamento de consultas médicas.
        .col-sm-12.col-md-7
          img(src="/static/images/paciente-computador.png")
      .clearfix
  section#beneficios.container-fluid(role="list")
    .container
      .col-sm-5.col-md-4.hidden-xs
        img.phone(src="/static/images/paciente-celular.png")
      .col-sm-7.col-md-8
        .col-sm-9.col-sm-offset-3.col-md-10.col-md-offset-2
          h2 Benefícios
        .row
          .col-xs-12.item
            .col-xs-12.co-sm-3.col-md-2
              img(src="/static/images/icons/05-paciente.png")
            .col-xs-12.col-sm-9.col-md-10
              h3 Seguro
              p
                | O sistema é completamente integrado ao Consultório do(a) seu(sua) médico(a). Agende e tenha a certeza que seu horário está reservado.
          .col-xs-12.item
            .col-xs-12.co-sm-3.col-md-2
              img(src="/static/images/icons/06-paciente.png")
            .col-xs-12.col-sm-9.col-md-10
              h3 Rápido
              p
                | Acesso direto a agenda do seu médico. Marque o melhor horário com o profissional de sua preferência.
          .col-xs-12.item
            .col-xs-12.co-sm-3.col-md-2
              img(src="/static/images/icons/07-paciente.png")
            .col-xs-12.col-sm-9.col-md-10
              h3 Econômico
              p
                | Não perca tempo com telefone e procure profissionais que atendam seu convênio ou que ofereçam consulta com valor interessante para você.
          .col-xs-12.item
            .col-xs-12.co-sm-3.col-md-2
              img(src="/static/images/icons/08-paciente.png")
            .col-xs-12.col-sm-9.col-md-10
              h3 Prático
              p
                | Acesse em qualquer lugar e em qualquer hora, e caso você não consiga ir na consulta, basta reagendar um novo horário.
  section#contato.container-fluid(role="contentinfo")
    .container
      .row
        .col-sm-6.col-sm-offset-1.col-md-5.left-col
          h2
            | Quais as dificuldades que você encontra no dia a dia quando resolve marcar uma consulta médica?
          h3
            | Conhecer a sua experiência nos levará
            br
            | ainda mais longe!
          p
            b Atendimento
            br
            |
            | Segunda à Sexta-feira das 09h00 às 18h00
          p
            b Telefone
            br
            a(
              href="tel:4135980860",
              style="color:inherit;text-decoration:none"
            ) 41 3598-0860
          p
            b E-mail
            br
            |
            | contato@medibook.com.br
        .col-sm-5.col-md-4.menina
  footer#footer.container-fluid
    #to-top(v-scroll-to="'#intro'")
      svg(
        version="1.1",
        baseprofile="basic",
        xmlns="http://www.w3.org/2000/svg",
        xmlns:xlink="http://www.w3.org/1999/xlink",
        xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
        x="0px",
        y="0px",
        width="16.446px",
        height="7.71px",
        viewbox="0 0 16.446 7.71",
        overflow="scroll",
        enable-background="new 0 0 16.446 7.71",
        xml:space="preserve"
      )
        defs
        g
          path(
            fill="#FFFFFF",
            d='M15.723,7.71c-0.186,0-0.37-0.071-0.512-0.212L9.757,2.044c-0.814-0.817-2.253-0.815-3.067,0L1.234,7.498\
            c-0.282,0.281-0.74,0.281-1.022,0c-0.283-0.283-0.283-0.741,0-1.023l5.455-5.454c1.36-1.36,3.752-1.361,5.113,0l5.454,5.454\
            c0.282,0.283,0.282,0.74,0,1.023C16.093,7.639,15.908,7.71,15.723,7.71z'
          )
    .container
      .row
        .col-sm-10.col-sm-offset-1.col-md-3
          img.logo(src="/static/images/logo.svg")
          p
            | Medibook® é um serviço de agendamento de consultas e eventos de saúde, criado para atender as demandas de saúde existentes e facilitar o acesso à medicina de forma simples e eficiente. Trata-se de um serviço gratuito, sem custo para usuários e profissionais
            | de saúde.
        .col-sm-10.col-sm-offset-1.col-md-2
          .title Mapa do Site
          ul
            a(href="", v-scroll-to="'#apresentacao'")
              li Apresentação
            a(href="", v-scroll-to="'#beneficios'")
              li Benefícios
            a(href="", v-scroll-to="'#contato'")
              li Contato
            a(@click.prevent="goToTerms()", target="_blank")
              li Termos de Uso
            a(@click.prevent="goToPolicy()", target="_blank")
              li Políticas de Privacidade
        .col-sm-10.col-sm-offset-1.col-md-3
          .title Contato
          //-.phone
          a.mb-cursor-pointer(
            href="tel:4135980860",
            style="color:inherit;text-decoration:none;"
          ) &nbsp;
            i.fa.fa-phone &nbsp;
            | 41 3598-0860
          a.mb-cursor-pointer(
            href="mailto:contato@medibook.com.br",
            style="color:inherit;text-decoration:none;"
          )
            i.fa.fa-envelope &nbsp;
            | contato@medibook.com.br

          .social
            a(href="")
              .icon.facebook
                svg(
                  version="1.1",
                  baseprofile="basic",
                  xmlns="http://www.w3.org/2000/svg",
                  xmlns:xlink="http://www.w3.org/1999/xlink",
                  xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
                  x="0px",
                  y="0px",
                  width="8.842px",
                  height="18.446px",
                  viewbox="0 0 8.842 18.446",
                  overflow="scroll",
                  enable-background="new 0 0 8.842 18.446",
                  xml:space="preserve"
                )
                  defs
                  path(
                    fill="#2071B6",
                    d='M8.842,3.097c-0.575,0-1.128-0.005-1.68,0.003C6.936,3.103,6.708,3.116,6.486,3.157\
                      C6.055,3.236,5.83,3.473,5.818,3.912C5.799,4.635,5.813,5.358,5.813,6.111c0.905,0,1.836,0,2.799,0\
                      C8.571,6.5,8.535,6.858,8.497,7.215C8.432,7.821,8.36,8.426,8.302,9.033c-0.015,0.156-0.072,0.2-0.225,0.198\
                      C7.396,9.224,6.715,9.228,6.034,9.228c-0.076,0-0.152,0-0.252,0c0,3.086,0,6.146,0,9.218c-1.396,0-2.768,0-4.166,0\
                      c0-3.069,0-6.129,0-9.218c-0.413,0-0.801,0-1.189,0C0,9.228,0,9.228,0,8.803c0-0.809,0-1.617,0-2.426c0-0.077,0-0.153,0-0.251\
                      c0.54,0,1.061,0,1.615,0c0-0.102-0.001-0.184,0-0.266C1.63,5.017,1.616,4.172,1.67,3.331c0.048-0.758,0.264-1.476,0.753-2.086\
                      C2.928,0.615,3.607,0.28,4.38,0.143c0.472-0.084,0.957-0.122,1.437-0.132c0.943-0.02,1.887-0.006,2.83-0.006\
                      c0.062,0,0.125,0.008,0.196,0.013C8.842,1.044,8.842,2.056,8.842,3.097z'
                  )
            a(href="")
              .icon.twitter
                svg(
                  version="1.1",
                  baseprofile="basic",
                  xmlns="http://www.w3.org/2000/svg",
                  xmlns:xlink="http://www.w3.org/1999/xlink",
                  xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
                  x="0px",
                  y="0px",
                  width="17.446px",
                  height="14.3px",
                  viewbox="0 0 17.446 14.3",
                  overflow="scroll",
                  enable-background="new 0 0 17.446 14.3",
                  xml:space="preserve"
                )
                  defs
                  g
                    path(
                      fill="#00C0F7",
                      d='M0,12.769c1.918,0.104,3.632-0.377,5.15-1.555c-1.076-0.087-1.973-0.511-2.666-1.335\
                        C2.199,9.538,1.983,9.159,1.84,8.705c0.534,0.077,1.041,0.084,1.602-0.083C2.3,8.332,1.474,7.714,0.954,6.716\
                        C0.689,6.208,0.55,5.664,0.571,5.058c0.503,0.244,1.004,0.411,1.578,0.428c-1.604-1.338-1.964-2.928-1.1-4.837\
                        c1.977,2.322,4.439,3.581,7.464,3.8c-0.02-0.181-0.036-0.337-0.055-0.492C8.24,2.175,9.542,0.402,11.312,0.073\
                        c1.248-0.232,2.34,0.084,3.261,0.96c0.1,0.095,0.191,0.095,0.306,0.068c0.666-0.155,1.3-0.394,1.9-0.723\
                        c0.05-0.028,0.102-0.051,0.188-0.094c-0.288,0.829-0.783,1.45-1.473,1.935c0.669-0.046,1.294-0.241,1.906-0.493\
                        c0.015,0.018,0.031,0.036,0.046,0.054c-0.345,0.386-0.681,0.779-1.038,1.153c-0.183,0.192-0.399,0.355-0.611,0.517\
                        c-0.102,0.078-0.131,0.158-0.132,0.285c-0.009,3.477-1.321,6.346-4.047,8.524c-1.408,1.125-3.044,1.742-4.833,1.956\
                        c-2.355,0.282-4.567-0.134-6.621-1.337C0.108,12.846,0.055,12.806,0,12.769z'
                    )
      .row
        .hidden-xs.col-sm-10.col-sm-offset-1.copyright
          .pull-left Medibook® - 2018 - Todos os direitos reservados.
          .pull-right
            | 80030-030 Curitiba - PR -&nbsp;
            a(
              href="tel:4135980860",
              style="color:inherit;text-decoration:none;display:inline-block"
            ) 41 35980860

        .hidden-sm.hidden-lg.col-sm-10.col-sm-offset-1.copyright
          .span.text-center Medibook® - 2018 - Todos os direitos reservados. 80030-030 Curitiba - PR -&nbsp;
            a(
              href="tel:4135980860",
              style="color:inherit;text-decoration:none;display:inline-block"
            ) 41 3598-0860
</template>
<style scoped>
.loading-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 300;
  flex-direction: column;
  user-select: none;
  border-radius: 5px;
}
.loading-circle {
  margin-left: 35%;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: 2px solid transparent;
  border-left-color: #387ab9;
  animation: circleanimation 0.45s linear infinite;
}
.loading-text {
  margin-top: 15px;
  color: #387ab9;
  font-size: 16px;
  font-weight: 600;
}
@keyframes circleanimation {
  from {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(360deg);
  }
}
#intro .content {
  height: 250px;
  position: absolute;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 5px;
  text-align: center;
  bottom: 79px;
}
#intro .content #search {
  display: inline-block;
  background: #00ce18;
  color: #ffffff;
  font-size: 16px;
  border-radius: 50px;
  padding: 6px 20px 6px 25px;
  -webkit-transition: color ease 0.3s, padding ease 0.3s;
  transition: color ease 0.3s, padding ease 0.3s;
  margin-top: 0px;
}
.mb-cursor-pointer {
  cursor: pointer;
}
.no-undeline {
  text-decoration: none;
}
.p-15 {
  padding: 15px;
}
#video {
  background: #f7f7f7;
  padding-top: 60px;
  padding-bottom: 60px;
  position: relative;
  z-index: 1;
  overflow: hidden;
  height: 440px;
}

#video:after {
  content: "";
  position: absolute;
  background: #2080cd;
  background: -webkit-gradient(
    linear,
    left top,
    right bottom,
    from(#2080cd),
    to(#164ac4)
  );
  background: linear-gradient(to bottom right, #2080cd, #164ac4);
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0;
  z-index: -1;
}

#video h2 {
  font-size: 38px;
  font-weight: 300;
  color: #ffffff;
  position: relative;
  margin-bottom: 30px;
}

#video h2 strong {
  font-weight: 400;
}

#video h2:after {
  content: "";
  position: absolute;
  width: 30px;
  height: 2px;
  background: #ffffff;
  left: 0px;
  bottom: -15px;
}

#video p {
  color: #ffffff;
  font-size: 20px;
  font-weight: 300;
}

#video img {
  max-width: 110%;
  position: relative;
  margin-top: -100px;
  image-rendering: crisp-edges;
}
.responsive-size {
  width: 49.333333%;
}
.border-shadow {
  -webkit-box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.55);
  -moz-box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.55);
  box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.55);
}
.cursor-point {
  cursor: pointer;
}
.avatar img {
  border-radius: 50%;
  position: relative;
  left: -5px;
  margin-left: -30px;
  z-index: 1;
}

.avatar-company-professional img {
  border-radius: 50%;
  position: relative;
  margin-top: -60px;
  margin-left: 40px;
  z-index: 1;
}

.avatar-company img {
  border-radius: 50%;
  position: relative;
  left: -5px;
  margin-left: -30px;
  z-index: 1;
}

.avatars {
  direction: rtl; /* This is to get the stack with left on top */
  text-align: left; /* Now Need to explitly align left */
  padding-left: 70px; /* Same Value as the negative margin */
}

.avatars-company {
  direction: rtl; /* This is to get the stack with left on top */
  text-align: left; /* Now Need to explitly align left */
  padding-left: 70px; /* Same Value as the negative margin */
}
.avatar-professional {
  z-index: 8;
  margin-top: 72px;
  margin-left: -58px;
  border-radius: 50%;
  -webkit-box-shadow: 2px 2px 11px 0px rgba(50, 50, 25, 1);
  -moz-box-shadow: 2px 2px 11px 0px rgba(50, 50, 25, 1);
  box-shadow: 2px 2px 11px 0px rgba(50, 50, 25, 1);
}

@media (max-width: 992px) {
  #intro .content {
    height: 338px;
    position: absolute;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 5px;
    text-align: center;
    bottom: 79px;
  }
  .avatar-professional {
    z-index: 8;
    margin-top: 0px;
    margin-left: -58px;
    border-radius: 50%;
    -webkit-box-shadow: 2px 2px 11px 0px rgba(50, 50, 25, 1);
    box-shadow: 2px 2px 11px 0px rgba(50, 50, 25, 1);
  }
  .avatar-company img {
    border-radius: 50%;
    position: relative;
    left: -5px;
    margin-left: -30px;
    z-index: 1;
  }

  .avatar-company-professional img {
    border-radius: 50%;
    position: relative;
    margin-top: -70px;
    margin-left: 70px;
    z-index: 1;
  }
}
@media (max-width: 767px) {
  #intro .content {
    height: 338px;
    position: absolute;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 5px;
    text-align: center;
    bottom: 79px;
  }
  #results h2 {
    font-weight: 300;
    font-size: 25px;
    position: relative;
    color: #333344;
    margin-bottom: 45px;
    text-align: center;
  }

  #results items h2 {
    font-weight: 300;
    font-size: 25px;
    position: relative;
    color: #333344;
    margin-bottom: 45px;
    text-align: center;
  }
  .results .item h4 {
    padding: 0px;
  }

  .results .item .info {
    margin-top: 5px;
    color: #555555;
    padding: 0px;
  }

  #consulta-particular {
    margin-top: 15px;
    padding: 0px 0px;
  }

  #planos,
  #consulta-particular {
    margin-top: 15px;
    padding: 0px 0px;
    font-size: 9px;
  }
  .responsive-size {
    width: 100%;
    height: 200px;
  }
  #video {
    background: #f7f7f7;
    padding-top: 60px;
    padding-bottom: 100px;
    position: relative;
    z-index: 1;
    overflow: hidden;
    height: 650px;
  }
  .avatar-company img {
    border-radius: 50%;
    position: relative;
    left: -5px;
    margin-left: -30px;
    z-index: 1;
    margin-top: -100px;
  }
  .avatar-professional {
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/patient/loading-page/gadget/index.vue